import { render, staticRenderFns } from "./layoutNoPadding.vue?vue&type=template&id=602470a2&scoped=true&"
import script from "./layoutNoPadding.vue?vue&type=script&lang=js&"
export * from "./layoutNoPadding.vue?vue&type=script&lang=js&"
import style0 from "./layoutNoPadding.vue?vue&type=style&index=0&id=602470a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602470a2",
  null
  
)

component.options.__file = "layoutNoPadding.vue"
export default component.exports